var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from 'react';
import { IdenticonsCustomProperty, useColorMap, identiconComponentName } from '../common';
import { styled } from '../../styled';
export var IdenticonAccessToken = styled(function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(".concat(IdenticonsCustomProperty.light, ", ").concat(colorMap.light, ")"),
        base: "var(".concat(IdenticonsCustomProperty.base, ", ").concat(colorMap.base, ")"),
        dark: "var(".concat(IdenticonsCustomProperty.dark, ", ").concat(colorMap.dark, ")"),
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M20.425 5.301L6.478 15.827c-2.109 1.591-2.99 4.4-2.182 6.96l5.325 16.9C10.43 42.262 12.756 44 15.38 44H32.62c2.624 0 4.95-1.742 5.76-4.312l5.324-16.9c.807-2.561-.073-5.37-2.182-6.96L27.585 5.3a5.911 5.911 0 00-7.16 0z", fill: fills.dark }),
        React.createElement("path", { d: "M19.516 36.157a6.346 6.346 0 01-4.47-1.831l-.061-.061a6.33 6.33 0 01-1.796-4.543c.03-1.7.72-3.286 1.942-4.468a6.34 6.34 0 017.876-.772l3.031-3.031 4.437-4.437.01-.01.666-.666a1.256 1.256 0 011.775 1.775l-1.182 1.181 1.902 1.902c.49.49.49 1.285 0 1.775l-2.834 2.83c-.49.489-1.283.489-1.775 0l-1.902-1.903-2.34 2.34a6.376 6.376 0 01-.75 8.027 6.338 6.338 0 01-4.529 1.892zm.035-9.326a2.995 2.995 0 00-2.151 5.075l.021.021a2.997 2.997 0 004.232-.028 2.96 2.96 0 00.862-2.12 2.965 2.965 0 00-.864-2.084l-.021-.019a2.98 2.98 0 00-2.079-.845z", fill: fills.light })));
}, {
    name: identiconComponentName,
})({});
